import Grid from 'antd/es/grid';

/**
 * This hook is used to determine if the screen is in single column mode
 *
 * @returns
 */
export const useSingleColumn = () => {
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();

  const isLoading = !(screens && Object.keys(screens).length > 0);

  return { isSingleColumn: isLoading ? false : !screens.xl, isLoading };
};
